import DocumentCreationButton from 'Components/DocumentCreationButton';
import { Item } from 'Components/Grid';
import HistoryRowControls from 'Components/HistoryRowControls';
import HistoryRowListing from 'Components/HistoryRowListing';
import HistorySection from 'Components/HistorySection';
import { isNumber } from 'neuro-utils';
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { formatPartialDate } from 'Utility/date';

const HeartRate = ({ documents, startEdit }: IOwnProps): React.JSX.Element => {
  return (
    <HistorySection
      headerText={<FormattedMessage id={'clinicalstudy.heartRate'} />}
      newButton={
        <DocumentCreationButton
          name="heartRate"
          text={'clinicalstudy.newHeartRate'}
          onClick={startEdit({}, 'heartRate')}
          width={15}
          height={3}
          fontSize={14}
          alternate={true}
        />
      }
    >
      <HistoryRowListing
        documents={documents}
        headers={
          <>
            <Item xs={2}>
              <FormattedMessage id={'general.date'} />
            </Item>
            <Item xs={2}>
              <FormattedMessage id={'clinicalstudy.heartRate'} />
            </Item>
            <Item xs={6} />
          </>
        }
        contentFormat={d => (
          <>
            <Item xs={2} style={{ fontWeight: '600' }}>
              {formatPartialDate(d.date)}
            </Item>
            <Item xs={2}>
              {isNumber(d.heartRate) ? (
                <FormattedMessage id="clinicalstudy.heartRateUnit" values={{ n: d.heartRate }} />
              ) : (
                '-'
              )}
            </Item>
            <Item xs={2} />
            <Item xs={3} />
            <Item xs={3}>
              <HistoryRowControls document={d} startEdit={startEdit} />
            </Item>
          </>
        )}
      />
    </HistorySection>
  );
};

interface IOwnProps {
  documents: IDocumentWithTypeV2<'heartRate'>[];
  startEdit: StartEdit;
}

export default HeartRate;
